var map = {
	"./admin_settings.png": 1843,
	"./appraisals.png": 1844,
	"./catalog.png": 1845,
	"./catalogWhite.png": 1846,
	"./catalog_orders.png": 1847,
	"./cms.png": 1848,
	"./component-fields/Asset.png": 1849,
	"./component-fields/Blocks.png": 1850,
	"./component-fields/Boolean.png": 1851,
	"./component-fields/Date-time.png": 1852,
	"./component-fields/LInk.png": 1853,
	"./component-fields/Markdown.png": 1854,
	"./component-fields/Multi asset.png": 1855,
	"./component-fields/Multi options.png": 1856,
	"./component-fields/Number.png": 1857,
	"./component-fields/Richtext.png": 1858,
	"./component-fields/Single options.png": 1859,
	"./component-fields/Table.png": 1860,
	"./component-fields/Text area.png": 1861,
	"./component-fields/Text.png": 1862,
	"./components.png": 1863,
	"./configuration.png": 1864,
	"./contents.png": 1865,
	"./crm.png": 1866,
	"./custom_order.png": 1867,
	"./customer_credits.png": 1868,
	"./customer_list.png": 1869,
	"./dashboard.png": 1870,
	"./finance.png": 1871,
	"./home.png": 1872,
	"./integrations.png": 1873,
	"./inventory-transfers.png": 1874,
	"./invoice-list.png": 1875,
	"./layaway.png": 1876,
	"./move.png": 1877,
	"./new_sale.png": 1878,
	"./orders.png": 1879,
	"./outgoing-consignments.png": 1880,
	"./payment-methods/amex.png": 1192,
	"./payment-methods/discover.png": 1191,
	"./payment-methods/mastercard.png": 1190,
	"./payment-methods/visa.png": 1189,
	"./payments.png": 1881,
	"./plus.png": 1398,
	"./register.png": 1882,
	"./repair_center.png": 1883,
	"./reports.png": 1884,
	"./services.png": 1885,
	"./trade_in_center.png": 1886
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1774;